export const downloadObj = {
  id: "download",
  lightBg: false,
  topLine: "Download",
  heading: "Unlimited space experience only for real gamers",
  description: "Click button below to get your milk back!",
  buttonLabel: "Download",
  btnDestination: null,
  imgStart: false,
  img: require("../../../../img/astronaut.svg"),
  alt: "image",
  download: true,
  url: "http://localhost:5000/download",
};

export const aboutObj = {
  id: "about",
  lightBg: true,
  topLine: "About",
  heading: "Simple game for complex experiences",
  description:
    "Play, have fun, destroy aliens, get your milk fuel back and don't let anyone to be better than you!",
  buttonLabel: "Gallery",
  btnDestination: "gallery",
  imgStart: true,
  img: require("../../../../img/aliens.svg"),
  alt: "image",
  download: false,
  url: null,
};
